import { render } from "./AppArkiva.vue?vue&type=template&id=7a966d62"
import script from "./AppArkiva.vue?vue&type=script&lang=js"
export * from "./AppArkiva.vue?vue&type=script&lang=js"

import "./AppArkiva.vue?vue&type=style&index=0&id=7a966d62&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__